import { Card, Divider } from 'antd';

export default function DefinitionsSection({ qt }) {
  const definitions = Array.from({ length: 12 }, (_, i) => i + 1);

  return (
    <Card
      title={qt('questionnaire.definitionsTitle')}
      className="mb-5"
      style={{ marginBottom: '20px', backgroundColor: '#f5f5f5' }}
    >
      {definitions.map((num) => (
        <div key={num} style={{ marginBottom: '15px' }}>
          <p style={{ marginBottom: '5px' }}>
            <strong>
              {num}. {qt(`questionnaire.definitionTitle${num}`)}
            </strong>
            {qt(`questionnaire.definitionAnswer${num}`)}
          </p>
          {num < 12 && <Divider style={{ margin: '10px 0' }} />}
        </div>
      ))}
    </Card>
  );
}
